const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOfficeSharePoint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "450px",
    height: "500px",
    viewBox: "0 0 450 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 92.18,
    y1: 477.480011,
    x2: 292.290009,
    y2: 214.839996,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,89.019608%,87.45098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "rgb(0%,59.215686%,65.882353%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(0%,46.666667%,56.862745%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: -777.140015,
    cy: 770.840027,
    fx: -777.140015,
    fy: 770.840027,
    r: 0.9,
    gradientTransform: "matrix(-98.022052,-236.879968,-426.555517,175.978041,252868.125,-319393.71875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "rgb(0%,23.137255%,36.470588%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "rgb(0%,29.019608%,42.352941%)",
      stopOpacity: 0.138039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(0%,43.529412%,58.039216%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    gradientUnits: "userSpaceOnUse",
    cx: -785.22998,
    cy: 766.900024,
    fx: -785.22998,
    fy: 766.900024,
    r: 0.9,
    gradientTransform: "matrix(-81.368639,-200.487205,-360.582879,145.895883,212855.734375,-269057.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(0%,16.470588%,25.882353%)",
      stopOpacity: 0.309804
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "rgb(0%,25.882353%,38.039216%)",
      stopOpacity: 0.213825
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(0%,43.529412%,58.039216%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    gradientUnits: "userSpaceOnUse",
    cx: -739.840027,
    cy: 872.710022,
    fx: -739.840027,
    fy: 872.710022,
    r: 0.9,
    gradientTransform: "matrix(-102.53313,149.242437,149.468015,102.381369,-206024.5,21094.220703)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(47.058824%,92.941176%,100%)",
      stopOpacity: 0.698039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,81.176471%,79.215686%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 245.139999,
    y1: 331.570007,
    x2: 411.899994,
    y2: 112.699997,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,89.019608%,87.45098%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(0%,63.529412%,72.156863%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "rgb(0%,38.823529%,48.627451%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    gradientUnits: "userSpaceOnUse",
    cx: -746.380005,
    cy: 743.75,
    fx: -746.380005,
    fy: 743.75,
    r: 0.9,
    gradientTransform: "matrix(56.607296,-162.280342,-292.839823,-101.831895,260296.265625,-45019.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0%,23.137255%,36.470588%)",
      stopOpacity: 0.501961
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "rgb(0%,29.803922%,42.352941%)",
      stopOpacity: 0.362199
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(0%,47.843137%,52.54902%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    gradientUnits: "userSpaceOnUse",
    cx: -741.460022,
    cy: 888.909973,
    fx: -741.460022,
    fy: 888.909973,
    r: 0.9,
    gradientTransform: "matrix(-85.443327,124.367318,124.552559,85.31498,-173675.6875,16546.900391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(47.058824%,92.941176%,100%)",
      stopOpacity: 0.698039
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,81.176471%,79.215686%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 153.419998,
    y1: 214.529999,
    x2: 259.709991,
    y2: 1.97,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "rgb(45.882353%,100%,96.470588%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "rgb(0%,78.039216%,81.960784%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "rgb(0%,58.823529%,67.843137%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 292.440002,
    y1: -12.27,
    x2: 235.630005,
    y2: 67.449997,
    gradientTransform: "matrix(1,0,0,-1,0,502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(5.490196%,35.294118%,36.470588%)",
      stopOpacity: 0.321569
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "rgb(7.058824%,42.352941%,41.960784%)",
      stopOpacity: 0.221945
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(10.980392%,58.039216%,54.117647%)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial5",
    gradientUnits: "userSpaceOnUse",
    cx: -686.599976,
    cy: 804.179993,
    fx: -686.599976,
    fy: 804.179993,
    r: 0.9,
    gradientTransform: "matrix(222.887003,222.576004,222.926115,-222.537381,-26208.169922,332025.53125)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(0%,71.372549%,74.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "rgb(0%,28.627451%,36.078431%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial6",
    gradientUnits: "userSpaceOnUse",
    cx: -686.070007,
    cy: 864.409973,
    fx: -686.070007,
    fy: 864.409973,
    r: 0.9,
    gradientTransform: "matrix(0.000000000000009539,155.789993,177.619995,-0.000000000000010876,-153439.140625,107241.640625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "rgb(11.764706%,52.156863%,50.588235%)",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "rgb(11.764706%,79.607843%,90.196078%)",
      stopOpacity: 0.6
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 187.789062 300 C 270.761719 300 338.019531 232.839844 338.019531 150 C 338.019531 67.160156 270.75 0 187.789062 0 C 104.828125 0 37.558594 67.160156 37.558594 150 C 37.558594 232.839844 104.820312 300 187.789062 300 Z M 187.789062 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M 187.789062 300 C 270.761719 300 338.019531 232.839844 338.019531 150 C 338.019531 67.160156 270.75 0 187.789062 0 C 104.828125 0 37.558594 67.160156 37.558594 150 C 37.558594 232.839844 104.820312 300 187.789062 300 Z M 187.789062 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial1)"
    },
    d: "M 187.789062 300 C 270.761719 300 338.019531 232.839844 338.019531 150 C 338.019531 67.160156 270.75 0 187.789062 0 C 104.828125 0 37.558594 67.160156 37.558594 150 C 37.558594 232.839844 104.820312 300 187.789062 300 Z M 187.789062 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial2)"
    },
    d: "M 187.789062 300 C 270.761719 300 338.019531 232.839844 338.019531 150 C 338.019531 67.160156 270.75 0 187.789062 0 C 104.828125 0 37.558594 67.160156 37.558594 150 C 37.558594 232.839844 104.820312 300 187.789062 300 Z M 187.789062 300 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 324.808594 400 C 393.949219 400 450 344.039062 450 275 C 450 205.960938 393.949219 150 324.808594 150 C 255.671875 150 199.621094 205.960938 199.621094 275 C 199.621094 344.039062 255.671875 400 324.808594 400 Z M 324.808594 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial3)"
    },
    d: "M 324.808594 400 C 393.949219 400 450 344.039062 450 275 C 450 205.960938 393.949219 150 324.808594 150 C 255.671875 150 199.621094 205.960938 199.621094 275 C 199.621094 344.039062 255.671875 400 324.808594 400 Z M 324.808594 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial4)"
    },
    d: "M 324.808594 400 C 393.949219 400 450 344.039062 450 275 C 450 205.960938 393.949219 150 324.808594 150 C 255.671875 150 199.621094 205.960938 199.621094 275 C 199.621094 344.039062 255.671875 400 324.808594 400 Z M 324.808594 400 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 206.558594 500 C 265.328125 500 312.96875 452.429688 312.96875 393.75 C 312.96875 335.070312 265.328125 287.5 206.558594 287.5 C 147.789062 287.5 100.148438 335.070312 100.148438 393.75 C 100.148438 452.429688 147.789062 500 206.558594 500 Z M 206.558594 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear3)"
    },
    d: "M 206.558594 500 C 265.328125 500 312.96875 452.429688 312.96875 393.75 C 312.96875 335.070312 265.328125 287.5 206.558594 287.5 C 147.789062 287.5 100.148438 335.070312 100.148438 393.75 C 100.148438 452.429688 147.789062 500 206.558594 500 Z M 206.558594 500 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial5)"
    },
    d: "M 40.660156 237.5 L 159.640625 237.5 C 182.097656 237.5 200.300781 255.703125 200.300781 278.160156 L 200.300781 396.839844 C 200.300781 419.296875 182.097656 437.5 159.640625 437.5 L 40.660156 437.5 C 18.203125 437.5 0 419.296875 0 396.839844 L 0 278.160156 C 0 255.703125 18.203125 237.5 40.660156 237.5 Z M 40.660156 237.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial6)"
    },
    d: "M 40.660156 237.5 L 159.640625 237.5 C 182.097656 237.5 200.300781 255.703125 200.300781 278.160156 L 200.300781 396.839844 C 200.300781 419.296875 182.097656 437.5 159.640625 437.5 L 40.660156 437.5 C 18.203125 437.5 0 419.296875 0 396.839844 L 0 278.160156 C 0 255.703125 18.203125 237.5 40.660156 237.5 Z M 40.660156 237.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57 372.148438 L 78.71875 360.828125 C 81.171875 365.769531 84.359375 369.410156 88.300781 371.75 C 92.289062 374.089844 96.660156 375.261719 101.390625 375.261719 C 106.660156 375.261719 110.679688 374.199219 113.441406 372.070312 C 116.210938 369.890625 117.589844 366.621094 117.589844 362.269531 C 117.589844 358.871094 116.261719 356 113.601562 353.660156 C 110.941406 351.269531 106.230469 349.460938 99.46875 348.238281 C 86.589844 345.898438 77.21875 341.808594 71.371094 335.960938 C 65.570312 330.109375 62.671875 322.828125 62.671875 314.121094 C 62.671875 303.28125 66.5 294.621094 74.171875 288.128906 C 81.828125 281.648438 91.949219 278.410156 104.511719 278.410156 C 112.96875 278.410156 120.421875 280.140625 126.859375 283.589844 C 133.300781 287.039062 138.410156 291.988281 142.191406 298.421875 L 120.960938 309.339844 C 118.621094 305.730469 116.089844 303.121094 113.378906 301.53125 C 110.660156 299.878906 107.261719 299.058594 103.160156 299.058594 C 98.261719 299.058594 94.539062 300.121094 91.980469 302.25 C 89.480469 304.378906 88.230469 307.140625 88.230469 310.539062 C 88.230469 313.460938 89.429688 316.039062 91.820312 318.269531 C 94.269531 320.449219 99.160156 322.230469 106.511719 323.609375 C 118.859375 325.949219 128.070312 330.199219 134.128906 336.371094 C 140.25 342.480469 143.308594 350.210938 143.308594 359.570312 C 143.308594 370.941406 139.660156 379.949219 132.371094 386.589844 C 125.078125 393.230469 114.671875 396.550781 101.160156 396.550781 C 91.371094 396.550781 82.53125 394.421875 74.660156 390.171875 C 66.839844 385.871094 60.960938 379.859375 57.019531 372.148438 Z M 57 372.148438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOfficeSharePoint);
export default __webpack_public_path__ + "static/media/Microsoft_Office_SharePoint.9b5e2363ed39a8648ac12f83542e2621.svg";
export { ForwardRef as ReactComponent };